import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './ForecastValue.css';

export enum ForecastValueType {
    positive = 'positive',
    neutral = 'neutral'
}

interface ForecastValueProps {
    children: JSX.Element | string;
    type: ForecastValueType;
}

export const ForecastValue = ({ children, type }: ForecastValueProps) => (
    <span
        className={Bem.cls({
            block: 'forecast-value',
            mods: {
                type
            }
        })}
    >
        {'+'}

        {children}
    </span>
);
